import React, { useRef } from "react";
import Navbar from "../components/navbar/Navbar";
import OnlineUsers from "../components/onlineUsers/OnlineUsers";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContex";
import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import Usersonline from "../components/users/Usersonline";
import axios from "axios";
import Conversations from "../components/conversations/Conversations";
import Message from "../components/message/Message";

export default function Chat() {
  const PS = process.env.REACT_APP_PUBLIC_SERVER;
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const { user } = useContext(AuthContext);
  const scrollRef = useRef();
  const [currentChat, setcurrentChat] = useState(null);
  const [messages, setcurrentmessages] = useState([]);
  const [onlineUsers, setonlineUsers] = useState([]);
  const [newMessage, setnewMessage] = useState("");
  const [conversationList, setconversationList] = useState({});

  const [arrivalMessage, setarrivalMessage] = useState(null);
  const [amigos, setAmigos] = useState([]);

  const socket = useRef(io("ws://localhost:8900"));
  const [conversations, setConversations] = useState([]);

  useEffect(() => {
    const buscarAmigos = async () => {
      try {
        const res = await axios.get("usuarios/asseguir/" + user._id);
        setAmigos(res.data);
        console.log("success");
      } catch (err) {
        console.log(err);
      }
    };
    buscarAmigos();
  }, [user._id]);

  useEffect(() => {
    socket.current = io("ws://localhost:8900");
    socket.current.on("getMessage", (data) => {
      setarrivalMessage({
        sender: data.senderId,
        text: data.text,
        createdAt: Date.now(),
      });
    });
  }, []);

  useEffect(() => {
    arrivalMessage &&
      currentChat?.members.includes(arrivalMessage.sender) &&
      setcurrentmessages((prev) => [...prev, arrivalMessage]);
  }, [arrivalMessage, currentChat]);

  useEffect(() => {
    socket.current.emit("addUser", user._id);
    socket.current.on("getUsers", (users) => {
      setonlineUsers(users);
    });
  }, [user]);

  const convolist = {};
  useEffect(() => {
    const getConversations = async () => {
      try {
        const res = await axios.get("conversations/" + user._id);
        setConversations(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    getConversations();
  }, [user._id]);

  useEffect(() => {
    const getMessages = async () => {
      try {
        const res = await axios.get("messages/" + currentChat?._id);
        setcurrentmessages(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    getMessages();
  }, [currentChat]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const message = {
      sender: user._id,
      text: newMessage,
      conversationId: currentChat._id,
    };

    const receiverId = currentChat.members.find(
      (member) => member !== user._id
    );

    socket.current.emit("sendMessage", {
      senderId: user._id,
      receiverId,
      text: newMessage,
    });

    try {
      const res = await axios.post("messages", message);
      setcurrentmessages([...messages, res.data]);
      setnewMessage("");
    } catch (err) {}
  };

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const openConversation = (id) => {
    conversations.map((c) =>
      c.members.map((m) =>
        m === id ? setcurrentChat(c) : setcurrentChat({ action: "preparing" })
      )
    );
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="page-title-box">
              <div className="page-title-right"></div>
              <h4 className="page-title">Chat</h4>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-3 col-lg-3">
            <div className="card">
              <div className="card-body p-0">
                <ul className="nav nav-tabs nav-bordered">
                  <li className="nav-item">
                    <a
                      href="#allUsers"
                      data-bs-toggle="tab"
                      aria-expanded="false"
                      className="nav-link active py-2"
                    >
                      Conversa
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div className="tab-pane show active p-3" id="newpost">
                    <div className="app-search">
                      <form>
                        <div className="mb-2 position-relative">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="People, groups & messages..."
                          />
                          <span className="mdi mdi-magnify search-icon"></span>
                        </div>
                      </form>
                    </div>

                    <div className="row">
                      <div className="col">
                        <div className="conversations">
                          {conversations.map((c) => (
                            <div onClick={() => setcurrentChat(c)}>
                              <Conversations
                                key={c._id}
                                conversation={c}
                                currnetUser={user}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-6 col-sm-12 ">
            <div className="card">
              {currentChat ? (
                <>
                  <div className="card-body">
                    <ul className="conversation-list scrollmessenger">
                      {messages.map((m) => (
                        <div ref={scrollRef}>
                          <Message
                            key={m._id}
                            message={m}
                            own={m.sender === user._id}
                            amigoId={m.sender}
                          />
                        </div>
                      ))}
                    </ul>

                    <div className="row">
                      <div className="col">
                        <div className="mt-2 bg-light p-3 rounded">
                          <form
                            className="needs-validation"
                            novalidate=""
                            name="chat-form"
                            id="chat-form"
                          >
                            <div className="row">
                              <div className="col mb-2 mb-sm-0">
                                <textarea
                                  className="form-control"
                                  onChange={(e) =>
                                    setnewMessage(e.target.value)
                                  }
                                  value={newMessage}
                                  placeholder="Escreve sua mensagem"
                                ></textarea>
                                <div className="invalid-feedback">
                                  Por favor insere uma mensagem
                                </div>
                              </div>
                              <div className="col-sm-auto">
                                <div className="btn-group">
                                  <a href="#" className="btn btn-light">
                                    <i className="uil uil-paperclip"></i>
                                  </a>
                                  <a href="#" className="btn btn-light">
                                    {" "}
                                    <i className="uil uil-smile"></i>{" "}
                                  </a>
                                  <div className="d-grid">
                                    <button
                                      onClick={handleSubmit}
                                      type="submit"
                                      className="btn btn-success chat-send"
                                    >
                                      <i className="uil uil-message"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <span className="text-center" style={{ fontSize: "70px" }}>
                  Abri uma conversa para começa o chat 📫
                </span>
              )}
            </div>
          </div>

          <div className="col-md-3 col-lg-3 scroll">
            <div className="card">
              <div className="card-body pb-0">
                <div className="dropdown float-end">
                  <a
                    href="#"
                    className="dropdown-toggle arrow-none card-drop"
                    data-bs-toggle="dropoown"
                    aria-expanded="false"
                  >
                    <i className="mdi mdi-dots-horizontal"></i>
                  </a>
                  <div className="dropdown-menu dropdown-menu-end">
                    <a className="dropdown-otem">View All</a>
                  </div>{" "}
                </div>

                <h4 className="header-title mb-3">Amigos</h4>
                {amigos.map((a) => (
                  <div onClick={() => openConversation(a._id)}>
                    <Usersonline key={a._id} usuarios={a} />
                  </div>
                ))}

                <div className="mt-2 mb-3 text-center"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
